import React from "react"
import { FaCheckCircle, FaTimesCircle } from "react-icons/fa"
import { useTranslation } from "react-i18next"
import clsx from "clsx"

import { posTerminalRequest } from "utils"
import { Button, Modal, Spinner } from "components"
import classes from "./PosTerminalPaymentStatusModal.module.scss"

const posTerminalPaymentStatusLevel = {
  "paymentFailed": -1,
  "failedRequest": 0,
  "sendingRequest": 1,
  "requestSent": 2,
  "acknowledge": 3,
  "paymentSuccess": 4
}

const PosTerminalPaymentStatusModal = props => {
  const {
    onPaymentSuccess = () => { },
    posTerminalPaymentStatus,
    setPosTerminalPaymentStatus,
    openPosTerminalPaymentStatusModal,
    setOpenPosTerminalPaymentStatusModal
  } = props

  const [t, i18n] = useTranslation()

  const handleHide = () => {
    setOpenPosTerminalPaymentStatusModal(false)
  }

  const handleComplete = () => {
    setOpenPosTerminalPaymentStatusModal(false)

    onPaymentSuccess()
  }

  const handleExited = () => {
    if (posTerminalPaymentStatus === "paymentSuccess") return

    posTerminalRequest.cancel()
  }

  const level =
    posTerminalPaymentStatusLevel[posTerminalPaymentStatus]

  const isLtr = i18n.dir(i18n.language) === "ltr"

  return (
    <Modal
      show={openPosTerminalPaymentStatusModal}
      onHide={handleHide}
      onExited={handleExited}
      onEnter={() => setPosTerminalPaymentStatus("sendingRequest")}
      backdrop="static"
    >
      <div className={classes["container"]}>

        <div className={classes["stages"]}>
          <div
            className={clsx(
              classes["stage"],
              level >= 1 && classes["active"]
            )}
          >
            1
          </div>

          <div
            className={clsx(
              classes["line"],
              level >= 2 && classes["active"]
            )}
          />

          <div
            className={clsx(
              classes["stage"],
              level >= 2 && classes["active"]
            )}
          >
            2
          </div>

          <div
            className={clsx(
              classes["line"],
              level >= 3 && classes["active"]
            )}
          />

          <div
            className={clsx(
              classes["stage"],
              level >= 3 && classes["active"]
            )}
          >
            3
          </div>

          <div
            className={clsx(
              classes["line"],
              level >= 4 && classes["active"]
            )}
          />

          <div
            className={clsx(
              classes["stage"],
              level >= 4 && classes["active"]
            )}
          >
            4
          </div>
        </div>

        <div className={classes["text-container"]}>
          {
            posTerminalPaymentStatus === "paymentFailed" &&
            <div className={classes["row"]}>
              <span className={classes["text"]}>
                {t("پرداخت_انجام_نشد")}
              </span>

              <FaTimesCircle
                size={20}
                color="var(--color-danger)"
                className={clsx(classes["icon"], isLtr && classes["icon-ltr"])}
              />
            </div>
          }

          {
            posTerminalPaymentStatus === "failedRequest" &&
            <div className={classes["row"]}>
              <span className={classes["text"]}>
                {t("درخواست_ارسال_نشد")}
              </span>

              <FaTimesCircle
                size={20}
                color="var(--color-danger)"
                className={clsx(classes["icon"], isLtr && classes["icon-ltr"])}
              />
            </div>
          }

          {
            posTerminalPaymentStatus === "sendingRequest" &&
            <div className={classes["row"]}>
              <span className={classes["text"]}>
                {t("در_حال_ارسال_درخواست")}
              </span>

              <Spinner
                className={clsx(classes["icon"], isLtr && classes["icon-ltr"])}
                color="var(--color-primary)"
              />
            </div>
          }

          {
            posTerminalPaymentStatus === "requestSent" &&
            <div className={classes["row"]}>
              <span className={classes["text"]}>
                {t("درخواست_ارسال_شد")}
              </span>

              <Spinner
                className={clsx(classes["icon"], isLtr && classes["icon-ltr"])}
                color="var(--color-primary)"
              />
            </div>
          }

          {
            posTerminalPaymentStatus === "acknowledge" &&
            <div className={classes["row"]}>
              <span className={classes["text"]}>
                {t("درخواست_دریافت_شد_در_حال_پرداخت")}
              </span>

              <Spinner
                className={clsx(classes["icon"], isLtr && classes["icon-ltr"])}
                color="var(--color-primary)"
              />
            </div>
          }

          {
            posTerminalPaymentStatus === "paymentSuccess" &&
            <div className={classes["row"]}>
              <span className={classes["text"]}>
                {t("پرداخت_انجام_شد")}
              </span>

              <FaCheckCircle
                size={20}
                color="var(--color-success)"
                className={clsx(classes["icon"], isLtr && classes["icon-ltr"])}
              />
            </div>
          }
        </div>

        <div className={classes["footer"]}>
          {posTerminalPaymentStatus === "paymentSuccess"
            ?
            <Button
              onClick={handleComplete}
              color="success"
            >
              {t("تایید")}
            </Button>
            :
            <Button
              onClick={handleHide}
              color="danger"
            >
              {t("لغو")}
            </Button>
          }
        </div>
      </div>
    </Modal>
  )
}

export default PosTerminalPaymentStatusModal